import React from 'react';
import { useIsOnScreen } from '@yme/hooks/useIsOnScreen';
import { MenuItem } from './MenuItem';
import { MenuListStyled } from './styled';
const INTERSECTION_THRESHOLD = 0.99;
export function MenuList({ items, labels, isRightToLeft }) {
    const { isOnScreen: isFirstOnScreen, ref: firstRef } = useIsOnScreen(INTERSECTION_THRESHOLD);
    const { isOnScreen: isLastOnScreen, ref: lastRef } = useIsOnScreen(INTERSECTION_THRESHOLD);
    const getRef = (index, length) => {
        if (index === 0) {
            return firstRef;
        }
        if (index === length - 1) {
            return lastRef;
        }
        return null;
    };
    return (React.createElement(MenuListStyled, { isFirstOnScreen: isFirstOnScreen, isLastOnScreen: isLastOnScreen, isRightToLeft: isRightToLeft }, items?.map((item, index, array) => {
        const ref = getRef(index, array.length);
        return (React.createElement(MenuItem, { item: item, headerLabels: labels, isRightToLeft: isRightToLeft, key: item.title, element: ref }));
    })));
}
